import { Controller } from "@hotwired/stimulus"

// Pause button of a logos marquee (Ui::Visitor::LogoMarqueeComponent). Hovering already pauses it in CSS, but
// moving content also needs a control that keyboard and touch users can reach (WCAG 2.2.2).
export default class extends Controller {
  static targets = ["button"]
  static classes = ["paused"]

  toggle () {
    const paused = this.buttonTarget.getAttribute("aria-pressed") !== "true"
    this.buttonTarget.setAttribute("aria-pressed", String(paused))
    this.element.classList.toggle(this.pausedClass, paused)
  }
}
